import { lazy } from 'react';

/**
 * Route table. Every page is code-split. `anyOf` gates navigation for UX only; the API enforces
 * all permissions independently and pages render forbidden/not-found states from API errors.
 */
export const pages = {
  login: lazy(() => import('@/features/auth/LoginPage')),
  forgot: lazy(() => import('@/features/auth/ForgotPasswordPage')),
  reset: lazy(() => import('@/features/auth/ResetPasswordPage')),
  accept: lazy(() => import('@/features/auth/AcceptInvitePage')),
  selectOrg: lazy(() => import('@/features/auth/SelectOrganizationPage')),
  security: lazy(() => import('@/features/auth/AccountSecurityPage')),
  platform: lazy(() => import('@/features/platform/PlatformTenantsPage')),
  dashboard: lazy(() => import('@/features/dashboard/DashboardPage')),
  company: lazy(() => import('@/features/organization/CompanyProfilePage')),
  departments: lazy(() => import('@/features/organization/DepartmentsPage')),
  teams: lazy(() => import('@/features/organization/TeamsPage')),
  locations: lazy(() => import('@/features/organization/LocationsPage')),
  calendars: lazy(() => import('@/features/organization/CalendarsPage')),
  settings: lazy(() => import('@/features/organization/SettingsPage')),
  users: lazy(() => import('@/features/users/UsersPage')),
  invitations: lazy(() => import('@/features/users/InvitationsPage')),
  roles: lazy(() => import('@/features/roles/RolesPage')),
  employees: lazy(() => import('@/features/employees/EmployeesPage')),
  employeeForm: lazy(() => import('@/features/employees/EmployeeFormPage')),
  employeeDetail: lazy(() => import('@/features/employees/EmployeeDetailPage')),
  employeeImport: lazy(() => import('@/features/employees/EmployeeImportPage')),
  changeRequests: lazy(() => import('@/features/employees/ChangeRequestsPage')),
  onboardingCases: lazy(() => import('@/features/onboarding/CasesPage')),
  onboardingCase: lazy(() => import('@/features/onboarding/CaseDetailPage')),
  onboardingTemplates: lazy(() => import('@/features/onboarding/TemplatesPage')),
  onboardingTemplate: lazy(() => import('@/features/onboarding/TemplateDetailPage')),
  leaveRequests: lazy(() => import('@/features/leave/LeaveRequestsPage')),
  leaveRequest: lazy(() => import('@/features/leave/LeaveRequestDetailPage')),
  leaveCalendar: lazy(() => import('@/features/leave/LeaveCalendarPage')),
  leaveTypes: lazy(() => import('@/features/leave/LeaveTypesPage')),
  leavePolicies: lazy(() => import('@/features/leave/LeavePoliciesPage')),
  leavePolicy: lazy(() => import('@/features/leave/LeavePolicyDetailPage')),
  assetInventory: lazy(() => import('@/features/assets/InventoryPage')),
  assetDetail: lazy(() => import('@/features/assets/AssetDetailPage')),
  assetAssignments: lazy(() => import('@/features/assets/AssignmentsPage')),
  assetConfig: lazy(() => import('@/features/assets/AssetConfigPage')),
  assetAudit: lazy(() => import('@/features/assets/AssetAuditPage')),
  reports: lazy(() => import('@/features/reports/ReportsPage')),
  audit: lazy(() => import('@/features/audit/AuditPage')),
  selfDashboard: lazy(() => import('@/features/self-service/SelfDashboardPage')),
  selfProfile: lazy(() => import('@/features/self-service/SelfProfilePage')),
  selfOnboarding: lazy(() => import('@/features/self-service/SelfOnboardingPage')),
  selfLeave: lazy(() => import('@/features/self-service/SelfLeavePage')),
  selfAssets: lazy(() => import('@/features/self-service/SelfAssetsPage')),
  selfDocuments: lazy(() => import('@/features/self-service/SelfDocumentsPage')),
};
